let headerCells = null;
let membershipTable = document.querySelector(".ly-membership__mobile--table");
let rows = null;
let tierTitles = document.querySelectorAll(".lion-tier-box__title");
let tierCurrencyValues = document.querySelectorAll(".lion-currency__value");
let tierNextValue = document.querySelector(".lion-tier-box__value-to-next");
let modalHeaderContent = document.querySelector(".ly-modal__header--content");
let moneyAmountData = [];
let cellsTitles = [];
let cellsSubtitles = [];

const fetchMembershipData = () => {
    return new Promise((resolve) => {
        const checkDataInterval = setInterval(() => {
            const data = {
                headerCells: document.querySelectorAll('.lion-tier-compare__header-cell'),
                rows: document.querySelectorAll('.lion-tier-benefits-compare__row'),
                tierTitles: document.querySelectorAll(".lion-tier-box__title"),
                tierCurrencyValues: document.querySelectorAll('[data-i18n-key="ui.dashboard.tiers.spend_amount"] .lion-currency__value'),
                tierNextValue: document.querySelector(".lion-tier-box__value-to-next"),
            };
            
            if (data.headerCells.length && data.tierCurrencyValues.length) {
                clearInterval(checkDataInterval);
                resolve(data);
            }
        }, 500);
    });
};

const processFetchedData = async () => {
    try {
        const data = await fetchMembershipData();
        headerCells = data.headerCells;
        rows = data.rows;
        tierTitles = data.tierTitles;
        tierCurrencyValues = data.tierCurrencyValues;
        tierNextValue = data.tierNextValue;

        if (tierNextValue) {
            modalHeaderContent.innerHTML = tierNextValue.innerHTML;
        }

        if (headerCells.length > 0) {
            headerCells[0].textContent = "Rewards";
        }

        getHeaderCellsTitle();
        setTimeout(getHeaderCellsSubtitles, 1000);
        setTimeout(membershipData, 1500);

        populateMoneyAmountData();
    } catch (error) {
        console.error('Error processing data:', error);
    }
};

const populateMoneyAmountData = () => {
    if (!headerCells || !tierCurrencyValues) {
        console.error('Required data is missing.');
        return;
    }

    if (headerCells.length === 0 || tierCurrencyValues.length === 0) {
        console.error('No headerCells or tierCurrencyValues found.');
        return;
    }

    headerCells.forEach((title, index) => {
        if (index > 0) {
            tierCurrencyValues.forEach((currency, currencyIndex) => {
                if (currency && currency.textContent) {
                    setTimeout(() => {
                        moneyAmountData.push({
                            id: index - 1,
                            amount: currency.textContent.trim(),
                            title: title.textContent.trim(),
                        });
                    }, (index - 1) * tierCurrencyValues.length * 100 + currencyIndex * 100);
                } else {
                    console.warn(`Currency value at index ${currencyIndex} is undefined.`);
                }
            });
        }
    });
};

const getHeaderCellsTitle = () => {
    headerCells.forEach((cell, index) => {
        if (index > 0) {
            const title = cell.textContent.trim();
            if (title) {
                cellsTitles.push(title);
            }
        }
    });
};

const getHeaderCellsSubtitles = () => {
    rows.forEach((row) => {
        const benefit = row.querySelector('.lion-tier-benefits-compare__benefit-text').textContent.trim();
        const cells = row.querySelectorAll('.lion-tier-benefits-compare__row-cell');
        cells.forEach((cell, index) => {
            if (cell.querySelector('.lion-tier-benefits-compare__benefit-status-circle')) {
                const title = cellsTitles[index - 1];
                if (!cellsSubtitles[title]) {
                    cellsSubtitles[title] = [];
                }
                cellsSubtitles[title].push(benefit);
            }
        });
    });
};

const membershipData = () => {
    let markup = '';

    cellsTitles.forEach((title, index) => {
        let benefitsMarkup = '';
        if (cellsSubtitles[title]) {
            cellsSubtitles[title].forEach((benefit) => {
                benefitsMarkup += `<p>${benefit}</p>`;
            });
        }

        markup += `
            <div class="ly-membership__mobile--item">
                <div class="ly-membership__left--wrapper">
                    <h4 class="ly-membership__subtitle">${title}</h4>
                    <span class="ly-membership__first-span">${(index == 0) ? '$0' : moneyAmountData[index - 1].amount}</span>
                </div>
                <div style="margin-top: 4px;">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="6.5" cy="7.24268" rx="6.5" ry="6.26514" fill="#D9D9D9"/>
                    </svg>
                    <hr class="ly-membership__line">
                </div>
                <div class="ly-membership__right--wrapper">
                    <h4 class="ly-membership__subtitle">Rewards</h4>
                    <p>${benefitsMarkup}</p>
                </div>
            </div>
        `;
    });

    membershipTable.innerHTML = markup;

    headerCells.forEach((cell, index) => {
        if (index > 0 && moneyAmountData[index - 1]) {
            if(index == 1){
                const amount = '$0 +';
                cell.innerHTML = `${cell.innerHTML.trim()} <span style="font-size: 13px; display: block; margin-top: 3px;">${amount}</span>`;
            }else{
                const amount = moneyAmountData[index - 2].amount + ' +';
                cell.innerHTML = `${cell.innerHTML.trim()} <span style="font-size: 13px; display: block; margin-top: 3px;">${amount}</span>`;
            }
        }
    });
};

export default processFetchedData;